import { BaseSyntheticEvent, CSSProperties } from 'react'
import type {} from '@mui/lab/themeAugmentation'

import type { ValidateOptions } from '.'

export type Primitive = string | boolean | number
export type Nil = null | undefined
export type ClassesType<T extends (...args: any) => any> = Partial<
ReturnType<T>
>

export enum CountryCode {
  BR = 'BR',
  CA = 'CA',
  ES = 'ES',
  PT = 'PT',
  US = 'US',
}

export type IdObject = {
  id: string
  name?: string
}

export type AmountObj = { high: number; low: number }
export type Amount = AmountObj | number

export type Language = {
  code: string
  fullName: string
  id: number
  name: string
}

export type UnitsState = {
  temperature: string
  weight: string
}

export type ValueOf<T> = T[keyof T]

export interface ValidateHandle {
  validate: (options?: ValidateOptions) => boolean
}

export type AtLeast<T, K extends keyof T> = Partial<T> & Pick<T, K>

export enum PluralForms {
  ONE = 'ONE',
  OTHER = 'OTHER',
  ONE_OR_OTHER = 'ONE_OR_OTHER',
}

export enum SentenceFormatter {
  REGULAR = 'REGULAR',
  UPPER = 'UPPER',
  LOWERCASE = 'LOWERCASE',
  CAPITALIZE = 'CAPITALIZE',
}

export type CSSPropertiesMap = Record<string, CSSProperties>

export interface IFrameEvent
  extends BaseSyntheticEvent<Event, HTMLIFrameElement, HTMLIFrameElement> {}

type Enumerate<
  N extends number,
  Acc extends number[] = [],
> = Acc['length'] extends N
  ? Acc[number]
  : Enumerate<N, [...Acc, Acc['length']]>

// https://stackoverflow.com/questions/39494689/is-it-possible-to-restrict-number-to-a-certain-range
export type IntRange<F extends number, T extends number> = Exclude<
Enumerate<T>,
Enumerate<F>
>
